// extracted by mini-css-extract-plugin
export default {"editButton":"addDeduction_editButton__zI+wr","TableBody":"addDeduction_TableBody__6VixN","deleteButton":"addDeduction_deleteButton__ZA0JA"};